import { useState, useEffect } from 'react';

const SocialMediaHero = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
    
    // Force video autoplay on mobile devices
    const iframe = document.querySelector('#social-hero-video') as HTMLIFrameElement;
    if (iframe) {
      // Add interaction event listener to start video on first touch/click
      const startVideo = () => {
        iframe.src = iframe.src + '&autoplay=1';
        document.removeEventListener('touchstart', startVideo);
        document.removeEventListener('click', startVideo);
      };
      
      document.addEventListener('touchstart', startVideo, { once: true });
      document.addEventListener('click', startVideo, { once: true });
    }
  }, []);

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-black">
      {/* Video Background */}
      <div className="absolute inset-0 w-full h-full z-0">
        <iframe 
          id="social-hero-video"
          src="https://player.vimeo.com/video/1130619675?badge=0&autopause=0&player_id=0&app_id=58479&autoplay=1&loop=1&muted=1&background=1&controls=0&playsinline=1" 
          frameBorder="0" 
          allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" 
          referrerPolicy="strict-origin-when-cross-origin" 
          className="absolute top-1/2 left-1/2 w-screen h-screen min-w-full min-h-full transform -translate-x-1/2 -translate-y-1/2"
          style={{ 
            width: 'max(100vw, 177.78vh)',
            height: 'max(100vh, 56.25vw)'
          }}
          title="Black White Bold 3D Social Media Report Presentation"
        ></iframe>
      </div>

      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-black/70 z-1"></div>

      {/* Content */}
      <div className="relative z-10 container mx-auto px-6 text-center text-white">
        <div className={`max-w-4xl mx-auto transition-all duration-1000 ${
          isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'
        }`}>
          <div className="flex items-center justify-center space-x-3 mb-6">
            <div className="w-2 h-2 bg-[#d1bc8a] rounded-full animate-pulse"></div>
            <span className="text-sm uppercase tracking-wider text-gray-400">Social Media Marketing</span>
          </div>
          
          <div className="text-center max-w-4xl mx-auto">
            <h1 className="text-5xl md:text-7xl font-bold leading-tight mb-6">
              <span className="text-white">
                Bringen Sie Ihr Unternehmen ins{' '}
              </span>
              <span 
                className="text-[#d1bc8a] font-bold"
                style={{
                  textShadow: '0 0 10px rgba(209, 188, 138, 0.8), 0 0 20px rgba(209, 188, 138, 0.6), 0 0 30px rgba(209, 188, 138, 0.4)',
                  filter: 'drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3))'
                }}
              >
                digitale Rampenlicht
              </span>
            </h1>
            <p className="text-xl md:text-2xl text-gray-300 mb-12 leading-relaxed">
              Professionelle Social Media Betreuung, die Ihre Reichweite maximiert und echte Verbindungen zu Ihrer Zielgruppe schafft.
            </p>
          </div>


        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 text-white animate-bounce">
        <i className="ri-arrow-down-line text-2xl"></i>
      </div>
    </section>
  );
};

export default SocialMediaHero;
